import {
  Col,
  Row,
  Form,
  Nav,
  Card,
  Modal,
  Button,
  Badge,
  Table,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getUserRole, getUserProfile } from "@revbox/helpers-fe";
import { cookiesKeyNames } from "@revbox/common-fe";
import {
    userRoleTranslates,
    accountSettingsBreadcrumbLabel,
    navigationLabel,
    buttonLabel,
    userAccountLabels,
    userManagementLabels,
    userManagementTitle,
    addUserModalLabels,
    userManagementToasts,
    appvizerAlert
} from '@revbox/localization'

import Select from 'react-select'
import {
  editUser,
  createUser,
  getMyUsers,
  getMe,
  changePassword,
  getAllSubRoles,
  getAllAccessLevels,
  deleteUser,
  getAllRoles,
  getAllLanguages,
} from "../services/micro";
import { setUser } from "../features/user";
import {
  getWebhook,
} from "../services/pub";

import NotificationsCard from "../components/NotificationsCard";
import { getPathKey, useCookiesContext } from "../contexts/CookiesContext";
import useShowCurrency from "../hooks/useShowCurrency";
import { decrypt } from "../helpers/crypto";

import useGetLanguages from "../hooks/useGetLanguages";

const DEFAULT_ACCESS_LEVELS = [2, 3, 4, 5];

export const AdvertiserSettings = () => {
  const user = useSelector((state) => state.user);
  const [userProfile, setUserProfile] = useState();
  const [currentTab, setCurrentTab] = useState("user");
  const [myUsers, setMyUsers] = useState([]);
  const [userAccesses, setUserAccesses] = useState([]);
  const [subRoles, setSubRoles] = useState([]);
  const [accessLevels, setAccessLevels] = useState([]);
  const [webhook, setWebhook] = useState();
  const [exUser, setEditUser] = useState({
    firstName: userProfile?.first_name,
    lastName: userProfile?.last_name,
    email: userProfile?.email,
    role: userProfile?.role,
    access_levels: userProfile?.access_levels,
  });
  const { getLanguageAbbr, updateCookiesProperty } = useCookiesContext();
  const storedLanguage = getLanguageAbbr()
  const { languages, selectedLanguage, setSelectedLanguage } = useGetLanguages(user, storedLanguage)
  const [newUser, setNewUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    access_levels: DEFAULT_ACCESS_LEVELS,
    role: 4,
  });

  const dispatch = useDispatch();

  const { showCurrency, handleDisplayCurrencyState } = useShowCurrency(user)

  useEffect(() => {
    getWebhook(user.publisher_id)
      .then((res) => {
        if (res.success) {
          setWebhook(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    getAllAccessLevels()
      .then((res) => {
        if (res.success) {
          setAccessLevels(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });


    getAllSubRoles()
      .then((res) => {
        if (res.success) {
          setSubRoles(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    getAllRoles()
      .then((res) => {
        if (res.success) {

          const userAccessesData = res.data.find(
            (role) => role.name === user.role
          )?.avaliable_accesses;
          setUserAccesses(userAccessesData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [showNew, setShowNew] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const handleClose = () => {
    setShowNew(false);
    setShowEdit(false);
  };

  const handleShowNew = () => {
    setShowNew(true);
  };

  const handleShowEdit = (user) => {
    setEditUser({
      id: user.id,
      firstName: user.name.split(" ")[0],
      lastName: user.name.split(" ")[1],
      email: user.email,
      role: user.role,
      access_levels: user.access_levels,
    });
    setShowEdit(true);
  };

  const translatedToasts = userManagementToasts[storedLanguage]

  const handleDeleteUser = (user) => {
    deleteUser(user.id)
      .then((res) => {
        if (res.success) {
          toast.success(translatedToasts.userDeleted);
          getMyUsers()
            .then((res) => {
              if (res.success) {
                setMyUsers(res.data);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toast.error(translatedToasts.userDeletionFailed);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(translatedToasts.userDeletionFailed);
      });
  };

  useEffect(() => {
    getMyUsers()
      .then((res) => {
        if (res.success) {
          setMyUsers(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleChangePassword = (user_id) => {
    changePassword(user_id)
      .then((res) => {
        if (res && res.success) {
          toast.success(translatedToasts.emailSent);
        } else {
          toast.error(translatedToasts.passwordChangeFailed);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(translatedToasts.passwordChangeFailed);
      });
  };

  const handleChangeProfile = (e, field) => {
    setUserProfile({
      ...userProfile,
      [field]: e.target.value,
    });
  };

  const handleChangeNewUser = (e, field) => {
    setNewUser({
      ...newUser,
      [field]: e.target.value,
    });
  };

  const handleChangeTab = (tab) => {
    setCurrentTab(tab);
  };

  const getExUserPermission = (access_levels) => {
    if (!access_levels) {
      return "view";
    }

    const GET = accessLevels.find((level) => level.name === "GET");
    const POST = accessLevels.find((level) => level.name === "POST");
    const UPDATE = accessLevels.find((level) => level.name === "UPDATE");
    const DELETE = accessLevels.find((level) => level.name === "DELETE");

    if (
      access_levels.includes(GET.id) &&
      access_levels.includes(POST.id) &&
      access_levels.includes(UPDATE.id) &&
      access_levels.includes(DELETE.id)
    ) {
      return "all";
    } else if (
      access_levels.includes(GET.id) &&
      access_levels.includes(POST.id) &&
      access_levels.includes(UPDATE.id)
    ) {
      return "edit";
    } else {
      return "view";
    }
  };

  const handleChangeEditUserPermissions = (e) => {
    const GET = accessLevels.find((level) => level.name === "GET");
    const POST = accessLevels.find((level) => level.name === "POST");
    const UPDATE = accessLevels.find((level) => level.name === "UPDATE");
    const DELETE = accessLevels.find((level) => level.name === "DELETE");

    if (e.target.value === "view") {
      setEditUser({
        ...exUser,
        access_levels: [GET.id],
      });
    } else if (e.target.value === "edit") {
      setEditUser({
        ...exUser,
        access_levels: [GET.id, POST.id, UPDATE.id],
      });
    } else if (e.target.value === "all") {
      setEditUser({
        ...exUser,
        access_levels: [GET.id, POST.id, UPDATE.id, DELETE.id],
      });
    }
  };

  const handleChangeNewUserPermissions = (e) => {
    const GET = accessLevels.find((level) => level.name === "GET");
    const POST = accessLevels.find((level) => level.name === "POST");
    const UPDATE = accessLevels.find((level) => level.name === "UPDATE");
    const DELETE = accessLevels.find((level) => level.name === "DELETE");

    if (e.target.value === "view") {
      setNewUser({
        ...newUser,
        access_levels: [GET.id],
      });
    } else if (e.target.value === "edit") {
      setNewUser({
        ...newUser,
        access_levels: [GET.id, POST.id, UPDATE.id],
      });
    } else if (e.target.value === "all") {
      setNewUser({
        ...newUser,
        access_levels: [GET.id, POST.id, UPDATE.id, DELETE.id],
      });
    }
  };

  const handleChangeEditUser = (e, field) => {
    setEditUser({
      ...exUser,
      [field]: e.target.value,
    });
  };

  const handleSaveChanges = () => {
    editUser(userProfile.id, {
      email: userProfile.email,
      first_name: userProfile.firstName,
      last_name: userProfile.lastName,
      language: selectedLanguage,
      currency: showCurrency ? "1" : "0"
    })
      .then(async (res) => {
        if (res.success) {
          const toastText = userManagementToasts[selectedLanguage.value] || userManagementToasts[storedLanguage];
          const me = await getMe();
          dispatch(setUser(me.data));
          updateCookiesProperty(cookiesKeyNames.language, selectedLanguage)
          toast.success(toastText.profileUpdated);
        } else {
          toast.error(translatedToasts.profileUpdateFailed);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(translatedToasts.profileUpdateFailed);
      });
  };

  const handleEditChanges = () => {
    editUser(exUser.id, {
      email: exUser.email,
      first_name: exUser.firstName,
      last_name: exUser.lastName,
      role: exUser.role,
      access_levels: exUser.access_levels,
      language: selectedLanguage
    })
    .then(async (res) => {
      if (res.success) {
        const toastText = userManagementToasts[selectedLanguage.value] || userManagementToasts[storedLanguage];
          const users = await getMyUsers();
          setMyUsers(users.data);
          setShowEdit(false);
          toast.success(toastText.userUpdated);
          updateCookiesProperty(cookiesKeyNames.language, selectedLanguage)
          const advId = new URLSearchParams(window.location.search).get("advId");
          if (advId) {
            const decrypted_adv_id = decrypt(advId);
            if (decrypted_adv_id) {
              updateCookiesProperty(cookiesKeyNames.language, selectedLanguage, decrypted_adv_id)
            }
          }
        } else {
          toast.error(translatedToasts.userUpdateFailed);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(translatedToasts.userUpdateFailed);
      });
  };

  const handleCreateNewUser = () => {
    createUser({
      email: newUser.email,
      first_name: newUser.firstName,
      last_name: newUser.lastName,
      access_levels: newUser.access_levels,
      role: newUser.role,
    })
      .then((res) => {
        if (res.success) {
          toast.success(translatedToasts.newUserCreated);
        } else {
          toast.error(translatedToasts.newUserCreationFailed);
        }

        setNewUser({
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          role: 4,
          access_levels: [],
        });

        getMyUsers()
          .then((res) => {
            if (res.success) {
              setMyUsers(res.data);
            }
          })
          .catch((err) => {
            console.log(err);
          });

        handleClose();
      })
      .catch((err) => {
        console.log(err);
        toast.error("New user creation failed");
        handleClose();
      });
  };

  useEffect(() => {
    if (user) {
      const newUserProfile = getUserProfile(user);
      setUserProfile(newUserProfile);
    }
  }, [user]);

  const handleChangeLanguage = (selectedOption) => {
    setSelectedLanguage(selectedOption);
  }

  const userAccountLabelsData = userAccountLabels[storedLanguage]
  const userManagementLabelsData = userManagementLabels[storedLanguage]

  const isCustomUser = user.role === 'CUSTOMER';
  const userRole = getUserRole(user);
  const translatedUserRole = userRoleTranslates[storedLanguage][userRole];
  const addUserModalLabelsData = addUserModalLabels[storedLanguage]

  const apvAlertCondition = user.publisher_id === 73 || user.publisher_id === 34;

  if (userProfile)
    return (
      <React.Fragment>
        <div className="main main-app p-3 p-lg-4">
          <ol className="breadcrumb fs-sm mb-2">
            <li className="breadcrumb-item">
              <Link to="#">{translatedUserRole}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {accountSettingsBreadcrumbLabel[storedLanguage]}
            </li>
          </ol>
          <h2 className="main-title">{accountSettingsBreadcrumbLabel[storedLanguage]}</h2>
          <Nav className="nav-line mb-4">
            <Nav.Link href="#user" 
              className={currentTab === "user" ? "active" : ""} 
              onClick={(e) => {
                e.preventDefault();
                handleChangeTab("user")
              }}
            >{navigationLabel[storedLanguage].account}</Nav.Link>
            {userAccesses?.includes("user_account_management_access") && !isCustomUser && (
              <Nav.Link href="#account" 
                className={currentTab === "account" ? "active" : ""} 
                onClick={(e) => {
                  e.preventDefault();
                  handleChangeTab("account")
                }}
              >{navigationLabel[storedLanguage].management}</Nav.Link>
            )}
            {userAccesses?.includes("notifications_access") && (
              <Nav.Link href="#notifications" 
                className={currentTab === "notifications" ? "active" : ""} 
                onClick={(e) => {
                  e.preventDefault();
                  handleChangeTab("notifications")
                }}
              >{navigationLabel[storedLanguage].notifications}</Nav.Link>
            )}
          </Nav>

          {apvAlertCondition && (
            <div className="alert alert-warning d-flex justify-content-between align-items-center" role="alert">
              <div className="d-flex align-items-center">
                <i className="ri-alert-line me-2"></i>
                {appvizerAlert[storedLanguage].content}
              </div>
              <div>
                <a href={appvizerAlert[storedLanguage].link} target="_blank" rel="noopener noreferrer">
                  <Button variant="warning">
                    {appvizerAlert[storedLanguage].linkText} <i className="ri-external-link-line"></i>
                  </Button>
                </a>
              </div>
            </div>
          )}

          {currentTab === "user" && (
            <Card id="user" className="card-settings">
              <Card.Header>
                <Card.Title className="mb-0 d-flex justify-content-between">
                  <div>
                  {navigationLabel[storedLanguage].account}{" "}
                  <Badge bg="primary" className="ms-2">
                    {translatedUserRole}
                  </Badge>
                </div>
                <div>
                  <Button
                    variant="outline-primary"
                    onClick={handleSaveChanges}
                    size="sm"
                  >
                    {buttonLabel[storedLanguage].save}
                  </Button>
                </div>
              </Card.Title>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="setting-item">
                <Row className="g-2 align-items-center">
                  <Col md="5">
                    <h6>{userAccountLabelsData.firstName.title}</h6>
                    <p>{userAccountLabelsData.firstName.description}</p>
                  </Col>
                  <Col md>
                    <Form.Control
                      type="text"
                      disabled={user.publisher_id === 73}
                      placeholder="First name"
                      value={userProfile.firstName}
                      onChange={(e) => handleChangeProfile(e, "firstName")}
                    />
                  </Col>
                </Row>
              </div>
              <div className="setting-item">
                <Row className="g-2 align-items-center">
                  <Col md="5">
                    <h6>{userAccountLabelsData.lastName.title}</h6>
                    <p>{userAccountLabelsData.lastName.description}</p>
                  </Col>
                  <Col md>
                    <Form.Control
                      type="text"
                      placeholder="Last name"
                      disabled={user.publisher_id === 73}
                      value={userProfile.lastName}
                      onChange={(e) => handleChangeProfile(e, "lastName")}
                    />
                  </Col>
                </Row>
              </div>
              <div className="setting-item">
                <Row className="g-2 align-items-center">
                  <Col md="5">
                    <h6>{userAccountLabelsData.email.title}</h6>
                    <p>{userAccountLabelsData.email.description}</p>
                  </Col>
                  <Col md>
                    <Form.Control
                      type="text"
                      placeholder="Enter email address"
                      value={userProfile.email}
                      disabled={user.publisher_id === 73}
                      onChange={(e) => handleChangeProfile(e, "email")}
                    />
                  </Col>
                </Row>
              </div>
              <div className="setting-item">
                <Row className="g-2 align-items-center">
                  <Col md="5">
                    <h6>{userAccountLabelsData.password.title}</h6>
                    <p>{userAccountLabelsData.password.description}</p>
                  </Col>
                  <Col md>
                    <Button
                      variant="outline-primary"
                      onClick={() => handleChangePassword()}
                      size="sm"
                    >
                      {buttonLabel[storedLanguage].changePassword}
                    </Button>
                  </Col>
                </Row>
              </div>
                  <div className="setting-item">
                    <Row className="g-2 align-items-center">
                      <Col md="5">
                        <h6>{userAccountLabelsData.language.title}</h6>
                        <p>{userAccountLabelsData.language.description}</p>
                      </Col>
                      <Col md>
                        <Select
                          className="custom-select"
                          id="basic-select-single"
                          onChange={(option) => handleChangeLanguage(option)}
                          value={selectedLanguage}
                          options={languages}
                          placeholder={languages.find(language => language.value === selectedLanguage)?.label}
                          />
                      </Col>
                    </Row>
                  </div>
                  {getPathKey() !== 'pub' && (
                    <div className="setting-item">
                      <Row className="g-2 align-items-center">
                        <Col md="5">
                          <h6>{userAccountLabelsData.currency.title}</h6>
                          <p>{userAccountLabelsData.currency.description}</p>
                        </Col>
                        <Col md>
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            checked={showCurrency}
                            onChange={handleDisplayCurrencyState}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
            </Card.Body>
          </Card>
          )}
          {currentTab === "account" && !isCustomUser && (
            <Card id="account" className="card-settings mt-3">
              <Card.Header>
                <div className="d-flex justify-content-between">
                  <Card.Title>{navigationLabel[storedLanguage].management}</Card.Title>
                  <div className="card-settings">
                    <Button
                      variant="outline-primary"
                      onClick={handleShowNew}
                      size="sm"
                      title="This feature is not available yet"
                    >
                      {buttonLabel[storedLanguage].addUser}
                    </Button>
                    
                    {showNew && (
                        <Modal show={showNew} onHide={handleClose} centered>
                      <Modal.Header className="card-one" closeButton>
                        <Modal.Title>{addUserModalLabelsData.title}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body className="p-4 card-one">
                        <Row className="g-2">
                          <Col>
                            <Form.Label htmlFor="firstName">
                              {addUserModalLabelsData.firstName}
                            </Form.Label>
                            <Form.Control
                              id="firstName"
                              type="text"
                              placeholder={addUserModalLabelsData.firstName}
                              aria-label={addUserModalLabelsData.firstName}
                              onChange={(e) =>
                                handleChangeNewUser(e, "firstName")
                              }
                            />
                          </Col>
                          <Col>
                            <Form.Label htmlFor="lastName">
                              {addUserModalLabelsData.lastName}
                            </Form.Label>
                            <Form.Control
                              id="lastName"
                              type="text"
                              placeholder={addUserModalLabelsData.lastName}
                              aria-label={addUserModalLabelsData.lastName}
                              onChange={(e) =>
                                handleChangeNewUser(e, "lastName")
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 g-2">
                          <Col>
                            <Form.Label htmlFor="email">
                              {addUserModalLabelsData.email}
                            </Form.Label>
                            <Form.Control
                              id="email"
                              type="email"
                              placeholder={addUserModalLabelsData.email}
                              aria-label={addUserModalLabelsData.email}
                              onChange={(e) => handleChangeNewUser(e, "email")}
                            />
                          </Col>
                          <Col>
                            <Form.Label htmlFor="role">
                              {addUserModalLabelsData.role}
                            </Form.Label>
                            <Form.Select
                              id="role"
                              aria-label="Default select example"
                              onChange={(e) => handleChangeNewUser(e, "role")}
                            >
                              {subRoles &&
                                subRoles.map((role, index) => (
                                  <option key={index} value={role.id}>
                                    {userRoleTranslates[storedLanguage][role.alias]}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className="mt-2 g-2">
                          <Col>
                            <Form.Label htmlFor="permission">
                              {addUserModalLabelsData.permissions}
                            </Form.Label>
                            <Form.Select
                              isMulti
                              id="permission"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleChangeNewUserPermissions(e)
                              }
                            >
                              <option value="view">{addUserModalLabelsData.view}</option>
                              <option value="edit">{addUserModalLabelsData.viewEdit}</option>
                              <option value="all">{addUserModalLabelsData.viewEditDelete}</option>
                            </Form.Select>
                          </Col>
                        </Row>
                        {/* <Row className="mt-2 g-2">
                        <Col>
                          <Form.Label htmlFor="password">Password</Form.Label>
                          <Form.Control id="password" type="password" placeholder="********" aria-label="Password" onChange={(e) => handleChangeNewUser(e, 'password')} />
                        </Col>
                      </Row> */}
                      </Modal.Body>
                      <Modal.Footer className="card-one">
                        <Button variant="outline-primary" onClick={handleClose}>
                          {addUserModalLabelsData.discard}
                        </Button>
                        <Button variant="primary" onClick={handleCreateNewUser}>
                          {addUserModalLabelsData.inviteUser}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    )}
                    {showEdit && (
                      <Modal show={showEdit} onHide={handleClose} centered>
                      <Modal.Header className="card-one" closeButton>
                        <Modal.Title>{addUserModalLabelsData.editUser}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body className="p-4 card-one">
                        <Row className="g-2">
                          <Col>
                            <Form.Label htmlFor="firstName">
                              {addUserModalLabelsData.firstName}
                            </Form.Label>
                            <Form.Control
                              id="firstName"
                              type="text"
                              placeholder={addUserModalLabelsData.firstName}
                              aria-label={addUserModalLabelsData.firstName}
                              onChange={(e) =>
                                handleChangeEditUser(e, "firstName")
                              }
                              value={exUser.firstName}
                            />
                          </Col>
                          <Col>
                            <Form.Label htmlFor="lastName">
                              {addUserModalLabelsData.lastName}
                            </Form.Label>
                            <Form.Control
                              id="lastName"
                              type="text"
                              placeholder={addUserModalLabelsData.lastName}
                              aria-label={addUserModalLabelsData.lastName}
                              onChange={(e) =>
                                handleChangeEditUser(e, "lastName")
                              }
                              value={exUser.lastName}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 g-2">
                          <Col>
                            <Form.Label htmlFor="email">
                              {addUserModalLabelsData.email}
                            </Form.Label>
                            <Form.Control
                              id="email"
                              type="email"
                              placeholder={addUserModalLabelsData.email}
                              aria-label={addUserModalLabelsData.email}
                              onChange={(e) => handleChangeEditUser(e, "email")}
                              value={exUser.email}
                            />
                          </Col>
                          <Col>
                            <Form.Label htmlFor="role">
                              {addUserModalLabelsData.role}
                            </Form.Label>
                            <Form.Select
                              id="role"
                              aria-label="Default select example"
                              onChange={(e) => handleChangeEditUser(e, "role")}
                              value={exUser.role}
                            >
                              {subRoles &&
                                subRoles.map((role, index) => (
                                  <option key={index} value={role.id}>
                                    {userRoleTranslates[storedLanguage][role.alias]}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className="mt-2 g-2">
                          <Col>
                            <Form.Label htmlFor="permission">
                              {addUserModalLabelsData.permissions}
                            </Form.Label>
                            <Form.Select
                              isMulti
                              id="permission"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleChangeEditUserPermissions(e)
                              }
                              value={getExUserPermission(exUser.access_levels)}
                            >
                              <option value="view">{addUserModalLabelsData.view}</option>
                              <option value="edit">{addUserModalLabelsData.viewEdit}</option>
                              <option value="all">{addUserModalLabelsData.viewEditDelete}</option>
                            </Form.Select>
                          </Col>
                        </Row>
                        {/* <Row className="mt-2 g-2">
                        <Col>
                          <Form.Label htmlFor="password">Password</Form.Label>
                          <Form.Control id="password" type="password" placeholder="********" aria-label="Password" onChange={(e) => handleChangeNewUser(e, 'password')} />
                        </Col>
                      </Row> */}
                      </Modal.Body>
                      <Modal.Footer className="card-one">
                        <Button variant="outline-primary" onClick={handleClose}>
                          {addUserModalLabelsData.discard}
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={() => handleChangePassword(exUser.id)}
                        >
                          {addUserModalLabelsData.sendPasswordReset}
                        </Button>
                        <Button variant="primary" onClick={handleEditChanges}>
                          {addUserModalLabelsData.updateUser}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    )}
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="setting-item">
                  <Row className="g-2">
                    <Col md="5">
                      <h6>{userManagementTitle[storedLanguage].title}</h6>
                      <p>{userManagementTitle[storedLanguage].description}</p>
                    </Col>
                    <Col md>
                      <Table className="mb-0" responsive>
                        <thead>
                          <tr>
                            <th scope="col">{userManagementLabelsData.name}</th>
                            <th scope="col">{userManagementLabelsData.email}</th>
                            <th scope="col">{userManagementLabelsData.role}</th>
                            <th scope="col">{userManagementLabelsData.lastActive}</th>
                            <th scope="col">&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user && (
                            <tr style={{ opacity: 0.5 }}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="avatar">
                                    <span className="avatar-initial bg-primary">
                                      {user.first_name[0]}
                                    </span>
                                  </div>
                                  <span>
                                    {user.first_name} {user.last_name}
                                  </span>
                                </div>
                              </td>
                              <td>{user.email}</td>
                              <td>{translatedUserRole}</td>
                              <td>{userManagementLabelsData.now}</td>
                              <td></td>
                            </tr>
                          )}
                          
                          {
                            myUsers &&
                              myUsers.filter(u => u.id !== user.id).map((user, index) => {
                                if (user.is_publisher) {
                                  return (
                                    <tr style={{ opacity: 0.5 }}>
                                      <td>
                                        <div className="d-flex align-items-center gap-2">
                                          <div className="avatar">
                                            <span className="avatar-initial bg-primary">
                                              {user.name[0]}
                                            </span>
                                          </div>
                                          <span>
                                            {user.name}
                                          </span>
                                        </div>
                                      </td>
                                      <td>{user.email}</td>
                                      <td>
                                        {userRoleTranslates[storedLanguage]["Publisher"]}
                                      </td>
                                      <td>{userManagementLabelsData.now}</td>
                                      <td></td>
                                    </tr>
                                  )
                                } else {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-flex align-items-center gap-2">
                                          <div className="avatar">
                                            <span className="avatar-initial bg-primary">
                                              {user.name[0]}
                                            </span>
                                          </div>
                                          <span>{user.name}</span>
                                        </div>
                                      </td>
                                      <td>{user.email}</td>
                                      <td>
                                        {userRoleTranslates[storedLanguage][subRoles.find(role => role.id === user.role)?.alias]}
                                      </td>
                                      <td>
                                        {user.date
                                          ? new Date(
                                            Number(user.date)
                                          ).toLocaleDateString()
                                          : "N/A"}
                                      </td>
                                      <td>
                                        <Nav as="nav">
                                          <Link
                                            to=""
                                            onClick={() => handleShowEdit(user)}
                                          >
                                            <i className="ri-pencil-line"></i>
                                          </Link>
                                          <Link
                                            to=""
                                            onClick={() => handleDeleteUser(user)}
                                          >
                                            <i className="ri-delete-bin-line"></i>
                                          </Link>
                                        </Nav>
                                      </td>
                                    </tr>
                                  )
                                }
                            })
                          }
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          )}
          {currentTab === "notifications" && (
            <NotificationsCard user={user} userAccesses={userAccesses} showOnlyEmails={user.publisher_id === 73 || user.publisher_id === 34} />
          )}
          
        </div>
      </React.Fragment>
    );
};
